import { render, staticRenderFns } from "./WristbandListView.vue?vue&type=template&id=124a9e68&scoped=true"
import script from "./WristbandListView.vue?vue&type=script&lang=js"
export * from "./WristbandListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124a9e68",
  null
  
)

export default component.exports